import { createContext } from 'react';

import type {
  LiveHandler,
  PresenceHandlers,
  PublicationHandler,
  RealtimeStatus,
  Unsubscribe,
} from './types';

export interface RealtimeContextValue {
  status: RealtimeStatus;
  /** The caller's own channel in the active org, once a socket has been granted. */
  userChannel: string | null;
  /** The active org's presence channel, once a socket has been granted. */
  presenceChannel: string | null;
  subscribe: <T>(
    channel: string,
    handler: PublicationHandler<T>,
    onLive?: LiveHandler,
    presence?: PresenceHandlers,
  ) => Unsubscribe;
}

/**
 * The default IS the no-op contract: with no `VITE_CENTRIFUGO_URL` (or outside
 * a provider) nothing is registered and the app behaves as it did before
 * realtime existed — the bell keeps polling at its normal rate.
 */
export const RealtimeContext = createContext<RealtimeContextValue>({
  status: 'disabled',
  userChannel: null,
  presenceChannel: null,
  subscribe: () => () => {},
});
